import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { ApiResult } from '@synergy/api';
import { Dispatch } from 'redux';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';
import { uploadFilesSet } from '@synergy/data-access';

import { Api } from '../../../../../api';
import { AppState } from '../../../../../store/models/app-state';
import { Invoice } from '../../../models/invoice';
import { InvoiceRequest } from '../../models/invoice-request';
import { OverviewFormValues } from '../../models/overview-form-values';
import { StepData } from '../../../../../common/components/new-stepper/step-data';
import { resourceMissing } from '../../../../../common/reducers/resource-missing-reducer';

export const INVOICE_DETAIL_OVERVIEW_SUBMIT = 'INVOICE_DETAIL_OVERVIEW_SUBMIT';
export const INVOICE_DETAIL_OVERVIEW_FETCH = 'INVOICE_DETAIL_OVERVIEW_FETCH';
export const INVOICE_DETAIL_OVERVIEW_RECEIVE = 'INVOICE_DETAIL_OVERVIEW_RECEIVE';
export const INVOICE_DETAIL_OVERVIEW_SAVE = 'INVOICE_DETAIL_OVERVIEW_SAVE';
export const INVOICE_DETAIL_OVERVIEW_SAVE_ERROR = 'INVOICE_DETAIL_OVERVIEW_SAVE_ERROR';

export const submitOverview = (data: StepData<OverviewFormValues>) => ({
    type: INVOICE_DETAIL_OVERVIEW_SUBMIT,
    data,
});

export const fetchOverview = (id: number) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        const response = await api.invoices.get(id);
        if (response.success) {
            dispatch(uploadFilesSet(response.result.media));
            dispatch({ type: INVOICE_DETAIL_OVERVIEW_RECEIVE, invoice: response.result });
        } else if (404 === response.errorCode) {
            // Not a fault to report in passing: the address names a record
            // that does not exist, and the mask says so instead of standing empty.
            dispatch(resourceMissing());
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const saveOverview = () => {
    return async (dispatch: Dispatch, getState: () => AppState, { api }: { api: Api }) => {
        let response: ApiResult<Invoice>;

        dispatch({ type: INVOICE_DETAIL_OVERVIEW_SAVE });

        const invoice = getState().invoiceDetail.overview.stepData.values as Partial<Invoice>;

        const {
            items: _items,
            textItems: _textItems,
            netSurcharge: _netSurcharge,
            netShippingCosts: _netShippingCosts,
            paymentTerm: _paymentTerm,
            ...invoiceDetailOverviewData
        } = invoice;

        invoiceDetailOverviewData.paymentTermId = _paymentTerm?.id;
        invoiceDetailOverviewData.functionalAssetId = invoiceDetailOverviewData.functionalAsset?.id;
        invoiceDetailOverviewData.functionalAsset = undefined;
        invoiceDetailOverviewData.poolBankInfoId = invoiceDetailOverviewData.poolBankInfo?.id;
        invoiceDetailOverviewData.poolBankInfo = undefined;

        if (invoiceDetailOverviewData.id) {
            response = await api.invoices.patch(invoiceDetailOverviewData.id, invoiceDetailOverviewData as Invoice);
        } else {
            response = await api.invoices.post(invoiceDetailOverviewData as InvoiceRequest);
        }

        if (response.success) {
            dispatch({ type: INVOICE_DETAIL_OVERVIEW_RECEIVE, invoice: response.result });
        } else {
            dispatch({ type: INVOICE_DETAIL_OVERVIEW_SAVE_ERROR });
            return false;
        }

        return true;
    };
};
